<script setup lang="ts">
    export type BaseSelectOption = {
        label: string;
        value: string | number;
        disabled?: boolean;
        selected?: boolean;
    };

    defineProps<{
        options: BaseSelectOption[];
        modelValue?: string | number;
        id: string;
        name?: string;
        required?: boolean;
        ariaInvalid?: boolean;
        ariaDescribedby?: string;
    }>();

    const emit = defineEmits<{
        (e: 'update:modelValue', value: string | number): void;
    }>();

    const onChange = (event: Event) => {
        const value = (event.target as HTMLSelectElement).value;
        emit('update:modelValue', value);
    };
</script>

<template>
    <div class="base-select">
        <select
            v-bind="$attrs"
            :id="id"
            :value="modelValue"
            :name="name"
            :required="required"
            :aria-invalid="ariaInvalid"
            :aria-describedby="ariaDescribedby"
            @change="onChange"
        >
            <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
                :selected="option.selected"
                :disabled="option.disabled"
            >
                {{ option.label }}
            </option>
        </select>

        <img
            class="chevron"
            src="~/assets/icons/chevron-down.svg"
            alt=""
            aria-hidden="true"
        />
    </div>
</template>

<style scoped lang="scss">
    .base-select {
        position: relative;
        display: flex;
        align-items: center;

        select {
            @include text-label-bold;

            appearance: none;
            background: transparent;
            color: var(--gray);
            overflow: visible;
            padding-right: $spacing--2;
            padding-left: $spacing--05;
            text-transform: capitalize;

            cursor: pointer;
            border-radius: $border-radius-s;

            option:disabled {
                color: $form-gray-light;
                cursor: default;
            }
        }

        & .chevron {
            position: absolute;
            right: $spacing--05;
            top: 50%;
            transform: translateY(-50%);
            width: 18px;
            height: 18px;
            pointer-events: none;
            opacity: 0.5;
        }
    }
</style>
